// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1qSbl","title":"Images45_title__1OviU","images":"Images45_images__2vMgU"};